export type WorkspaceToastTone = 'success' | 'error' | 'warning' | 'info'

export type WorkspaceToastItem = {
  id: number
  tone: WorkspaceToastTone
  text: string
  durationMs: number
}

const DEFAULT_DURATION: Record<WorkspaceToastTone, number> = {
  success: 3500,
  error: 5500,
  warning: 4200,
  info: 5000,
}

let nextId = 1
let queue: WorkspaceToastItem[] = []
const listeners = new Set<(items: WorkspaceToastItem[]) => void>()
const timeoutById = new Map<number, ReturnType<typeof setTimeout>>()

function notify() {
  const snapshot = [...queue]
  listeners.forEach((l) => l(snapshot))
}

function removeToast(id: number) {
  const t = timeoutById.get(id)
  if (t) {
    clearTimeout(t)
    timeoutById.delete(id)
  }
  queue = queue.filter((item) => item.id !== id)
  notify()
}

/** 手动关闭某条 Toast（如用户点击 ×） */
export function dismissWorkspaceToast(id: number) {
  removeToast(id)
}

/**
 * 页面正上方全局提示（对齐旧伦理 workbench 的 vue-toastification 交互）
 */
export function showWorkspaceToast(payload: {
  tone: WorkspaceToastTone
  text: string
  durationMs?: number
}) {
  const durationMs = payload.durationMs ?? DEFAULT_DURATION[payload.tone]
  const item: WorkspaceToastItem = {
    id: nextId++,
    tone: payload.tone,
    text: payload.text,
    durationMs,
  }
  queue = [...queue, item]
  notify()
  const tid = setTimeout(() => removeToast(item.id), durationMs)
  timeoutById.set(item.id, tid)
}

export function subscribeWorkspaceToast(cb: (items: WorkspaceToastItem[]) => void) {
  listeners.add(cb)
  cb([...queue])
  return () => {
    listeners.delete(cb)
  }
}
